import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import NumberFormatType from "@mapmycustomers/shared/enum/NumberFormatType";

const canBeUnique = (dataType: CustomFieldDataType, displayType: null | NumberFormatType) =>
  [CustomFieldDataType.DECIMAL, CustomFieldDataType.INTEGER, CustomFieldDataType.TEXT].includes(
    dataType
  ) && displayType !== NumberFormatType.PERCENTAGE;

export default canBeUnique;
